__turbopack_context__.v({
  "clickableRow": "bondScreenerTable-module-scss-module__ODglOG__clickableRow",
  "scrollContainer": "bondScreenerTable-module-scss-module__ODglOG__scrollContainer",
});
